import { useState } from "react";

import { useExtensionPromotionEffect } from "app/custom-hooks/useExtensionPromotionEffect";
import { isEligibleForExtensionPromotion } from "app/UtilitiesAndConstants/UtilityFunctions/extensionPromotion";

import { SESSION_KEY_EXT_PROMO_SHOWN } from "../constants";

const wasShownThisSession = (): boolean => {
    try {
        return sessionStorage.getItem(SESSION_KEY_EXT_PROMO_SHOWN) === "true";
    } catch {
        return false;
    }
};

const markShownThisSession = (): void => {
    try {
        sessionStorage.setItem(SESSION_KEY_EXT_PROMO_SHOWN, "true");
    } catch {
        return;
    }
};

export const useExtensionPromotionIndicator = (): boolean => {
    const [shouldShow, setShouldShow] = useState(false);

    useExtensionPromotionEffect(
        () => isEligibleForExtensionPromotion() && !wasShownThisSession(),
        () => {
            markShownThisSession();
            setShouldShow(true);
        },
    );

    return shouldShow;
};
